import React from "react";
import { createRoot } from "react-dom/client";
import ReactQuery from "../enhancers/reactQuery";
import RlFooter from "../modules/footer/RlFooter";
import { settings } from "../shim/jsbridge";

const { product_name: productName } = settings || {};

const container = document.getElementById("footer_container");
const root = createRoot(container);

root.render(
  <ReactQuery>
    <RlFooter productName={productName} />
  </ReactQuery>
);
